export function QueryGetValue(searchParam: string) {
    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)
    return urlParams.get(searchParam)
}
